import React, { memo } from 'react';
import './Filters.css';
import MultipleSelect from './MultipleSelect';
import { useFiltersContext } from './hooks/useFiltersContext';

const CityFilter = ({ className = '' }) => {
    const { filters, cities, onFilterChange } = useFiltersContext();

    return (
        <div className={`filtros-container-dashboards ${className}`}>
            <MultipleSelect
                label="Cidade"
                options={cities}
                onChange={onFilterChange}
                name="cidade"
                className="select-cidade-dashboards"
                defaultValue={filters.cidade}
            />
        </div>
    );
};

export default memo(CityFilter);
